document.addEventListener("DOMContentLoaded", () => {
  const variantInput = document.querySelector('select[name="id"]');
  const quantityInput = document.querySelector("#quantity");
 
  if (variantInput) {
    console.log("current variant id (page load):", variantInput.value);

    variantInput.addEventListener('change', () => {
      console.log("current variant id (on change):", variantInput.value);
    });
  }

  document.body.addEventListener('click', function (e) {
    const btn = e.target.closest('.click_addcart');
    if (!btn) return;

    const addToCartBtn = document.querySelector('[name="add"]');

    if (addToCartBtn && addToCartBtn.disabled) {
      console.log("Product is sold out");
      return;
    }

    console.log("varinat input", variantInput);

    const variantId = variantInput ? variantInput.value : null;
    
    const quantity = quantityInput
    ? parseInt(quantityInput.value, 10) || 1
    : 1;

    console.log("Quantity", quantity);
    console.log("varinat id", variantId);

    if (!variantId) {
      console.log('Variant ID not found');
      return;
    }
    
  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(res => res.json())
      .then(() => {
        $.ajax({
          url: '/cart.js',
          dataType: 'json',
          cache: false,
          success(cart) {
          customRefreshCart(cart);

          let $cartContainer;

          if ($('#header').is(':visible')) {
            $cartContainer = $('#header .cart-container');
          } else if ($('.sticky_nav--stick').length) {
            $cartContainer = $('.sticky_nav .cart-container');
          } else {
            $cartContainer = $('.top-bar .cart-container');
          }

          // Open drawer
          $cartContainer.addClass('active_link');

          // Close after 3 seconds
          setTimeout(() => {
            $cartContainer.removeClass('active_link');
          }, 3000);
        },

        });
      })
      .catch(err => console.error('Add to cart failed:', err));
  });

  function customRefreshCart(cart) {

    if (cart.item_count === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $('[data-cart-form]').addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $('[data-cart-form]').removeClass('hidden');
    }

    // 1. Counter update
    $('.cart_count').each(function () {
      const $el = $(this);
      const currentText = $el.text() || '0';
      $el.text(currentText.replace(/[0-9]+/, cart.item_count));
    });

    // 2. Mini-cart items rebuild
    let cartItemsHTML = '';
    $.each(cart.items, (index, item) => {
      const lineID = index + 1;
      cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}">`
        + `<a href="${item.url}">`;
      if (item.image) {
        cartItemsHTML += `<div class="cart_image mini-cart__item-image"><img src="${item.image.replace('http:', '')}" alt="${item.title}" /></div>`;
      }
      cartItemsHTML += `</a><div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${item.title}</a></div>`;
      cartItemsHTML += `<div class="mini-cart__item-price"><span class="money">${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</span></div>`;
      cartItemsHTML += '<div class="product-quantity-box">';
      cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
      cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
      cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
      cartItemsHTML += '</div></div>';
      cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"></span></a>`;
      cartItemsHTML += '</li>';
    });
    $('.js-cart_items').html(cartItemsHTML);

    // 3. Subtotal update
    const subtotalHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span> <span>Subtotal</span>`;
    $('.js-cart_subtotal').html(subtotalHTML);
  }
});